import { Component } from 'react';
import { ReactComponent as Add } from 'assets/images/svg/add.svg';
import AddManageBroadcast from './Add';
import Pagination from 'Components/Pagination';
import DeleteButton from 'Components/Table/DeleteButton';
import DataTable from 'Container/DataTable/DataTableContainer';
import formUrlParams from 'Helpers/urlform';
import { AESdecrypt, getFormattedText } from 'Helpers/index';
import Image from 'Components/Common/Image';
import { CSVLink } from 'react-csv';
import dateFormat from 'dateformat';
import {  convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import { ModuleActions } from 'Constants/Modules.constants';
import Tooltip from 'Common/Table/Tooltip';
import { tableConstants } from 'Constants';

class ManageBroadcast extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className: tableConstants.NAME_WIDTH,
          title: 'Messages', // add class="user max" in div
          accessor: 'messages', /* API response */
          sortOption: false,
          cell: rowDetail => {
            const { index, rowIdx, messages, messageId } = rowDetail;
            let message = ''
            try {
              const decryptedMessage = JSON.parse(AESdecrypt(messages, messageId));
              message = decryptedMessage.message;    
            } catch (error) {
              
            }
            return (
              <td key={ index } data-row={ rowIdx } className={ tableConstants.NAME_WIDTH }>
                <div className='user-message data_tooltip'>
                  <Tooltip content={ getFormattedText(message) } />
                </div>
              </td>
            );
          },
        },
        {
          className: tableConstants.NAME_WIDTH,
          title: 'Messages Type',
          chooseOption: {
            name: 'messageTypeSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: 'messageType', /* API response */
          sortOption: true,
          cell: rowDetail => {
            const { index, rowIdx, messageType } = rowDetail;        
            return (
              <td key={ index } data-row={ rowIdx } className={ tableConstants.NAME_WIDTH }>
                <div className='user-message data_tooltip'>
                    <Tooltip content={ getFormattedText(messageType) } />
                </div>
              </td>
            );
          },
        },
        {
          className:tableConstants.NAME_WIDTH,
          title: 'Team Name',
          chooseOption: {
            name: 'teamNameSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: 'teamName', /* API response */
          sortOption: true,
          tooltip: true
        },
        {
          className:tableConstants.NAME_WIDTH,
          title: 'Created By',
          chooseOption: {
            name: 'createdBySearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: 'createdBy',
          cell: rowDetail => {
            const { index, rowIdx, createdBy, image } = rowDetail;
            return (
              <td key={ index } data-row={ rowIdx }   className={ tableConstants.NAME_WIDTH }>
                <div className='ctUserInfo'>
                  <div className='ctUserInfo_img'>
                    <Image imageToken={ image } />
                  </div>
                  <div className="data_tooltip" tooltip={ createdBy } ><span className='ctUserInfo_name text_ellipsis'>{createdBy}</span></div>
                </div>
                
              </td>
            );
          },
          sortOption: true,
        },
        {
          className:tableConstants.DATE_RANGE_WIDTH,
          title: 'Broadcasted Date & Time	',
          accessor: 'createdDate', /* API response */
          chooseOption: {
            name: 'createdDateSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch
          },
          cell: function(rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } id='created-date-time' className={ tableConstants.DATE_RANGE_WIDTH }>
               { content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ') }
              </td>
            );
          },
          sortOption: true,
        },
        {
          className:tableConstants.DEFAULT_WIDTH,
          title: 'Delivered Status',
          chooseOption: {
            name: 'deliveredStatusSearch',
            Component: 'DropDown',
            DropdownText:'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createDeliveredStatus
          },
          accessor: 'deliveredStatus',
          cell: function(rowDetail) {
            const { content, index } = rowDetail;
            const status =
              content === 1 ? (
                <>
                  <span className='sent'>Sent</span>
                </>
              ) : (
                <>
                  <span className='failed'>Failed</span>
                </>
              );
            return <td key={ index } className={ tableConstants.DEFAULT_WIDTH }>{status}</td>;
          },
          sortOption: true,
        },
       
        {
          title: 'Action',
          accessor: 'id',
          cell: rowDetail => {
            const { index, id, rowIdx,profile, ...rest } = rowDetail;
            const permission = profile && profile.Broadcast
            return (
              <td key={ index } data-row={ rowIdx } className='action'>
                { permission && !permission[ ModuleActions.delete ] && 'N/A' }
                { permission && permission[ ModuleActions.delete ] && <DeleteButton
                  remainningRecords={ this.props.responseArray.length }
                  deleteActionListener={ this.props.deleteBroadCast }
                  activeQuery={ this.state.filtered }
                  id={ id }
                  checkPermission = { permission && permission[ ModuleActions.delete ] }
                /> }
              </td>
            );
          }
        }
      ],
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      activeEditData: '',
      addBroadCastMenuStatus: false,
      editBroadCastMenuStatus: false,
      activeSort: {},
    };
    this.state = model;
  }

  /**
   * @event componentDidMount
   * @summary API call to fetch broadcast  details
   * @return {Object} return manage broadcast object
   */
  componentDidMount() {
    this.props.fetchBroadCast();
    this.props.exportBroadcast();
  }

  getActiveEditData = data => {
    this.setState(
      { activeEditData: data, editBroadCastMenuStatus: true },
      () => {
        document.getElementById(data.editClass).classList.add('open');
      }
    );
  };

  handleDateSearch = data => {
    for (const [ key, value ] of Object.entries(data)) {
      const newKey = (key === 'fromDate') ? 'createdFromDate' : 'createdToDate';
      this.formUrlParams(newKey,value)
    }
  };

  handleBroadcastDateSearch = data => {
    for (const [ key, value ] of Object.entries(data)) {
      const newKey = (key === 'fromDate') ? 'broadcastedFromDate' : 'broadcastedToDate';
      this.formUrlParams(newKey,value)
    }
  };

  createDeliveredStatus = () => {
    const statusArray = [ 'Failed', 'Sent' ];
    return statusArray.map((broadcast, index) => {
      return (
        <option key={ index } value={ index }>
          {broadcast}
        </option>
      );
    });
  };

  handleBroadcastStatus = () => {
    const statusArray = [ 'Disable', 'Enable' ];
    return statusArray.map((broadcast, index) => {
      return (
        <option key={ index } value={ index }>
          {broadcast}
        </option>
      );
    });
  };

  /**
   * @method formUrlParams
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @param {rest} rest - Rest object except name and value
   * @summary Construct the query string based on user selection
   * @return {function} call fetch broadcast user api after change local state
   */

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchBroadCast(updatedFilter);
      this.props.exportBroadcast(updatedFilter);
    });
  };

  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchBroadCast(updatedFilter);
    this.props.exportBroadcast(updatedFilter);
  }

  /**
   * @method hanldeAddAdmin
   * @summary open broadcast popup based click event
   * @return {none} undefined
   */
  hanldeAddAdmin = () => {
    this.setState({ addBroadCastMenuStatus: true }, () => {
      document.getElementById('addbroadcast').classList.add('open');
    });
  };

  /**
   * @method setPageLimit
   * @summary set page limit for view data per page
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @return { function } formUrlParams
   */

  setPageLimit = (name, value) => {
    this.formUrlParams(name, value, { pageLimit: value });
  };

  /**
   * @method handleSearch
   * @summary set the username and password state
   * @param {event} event - React onChange event
   * @return { function } formUrlParams
   */
  handleSearch = event => {
    const { name, value } = event.target;
    this.formUrlParams(name, value);
  };

  /**
   * @method closeBroadCastMenu
   * @summary close add broadcast popup
   * @return { object } updated manage broadcast state
   */

  closeBroadCastMenu = () => {
    this.setState({ addBroadCastMenuStatus: false, filtered: [] });
  };

  /**
   * @method closeEditBroadCastMenu
   * @summary close edit broadcast popup
   * @return { object } updated manage broadcast state
   */

  closeEditBroadCastMenu = () => {
    this.setState({ editBroadCastMenuStatus: false });
  };

  render() {
    const { addBroadCastMenuStatus, editBroadCastMenuStatus } = this.state;
    const { responseArray, profile, totalRecords, currentPage, exportBroadcastData } = this.props;
    const Permission = profile && profile.Broadcast
    return (
      <>
        <div className='grid1 pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='block_flex'>
              <h4> Manage Broadcast</h4>
            </div>
            <div className='block_flex'>
            { exportBroadcastData && exportBroadcastData.length !== 0 && <CSVLink
                  data = { exportBroadcastData }
                  filename = { 'Broadcast Details.csv' }
                  className = 'btn btn_green'
                  onClick={ () => {
                    console.log('Export Data'); // Your click handling logic
                  } }
                >
                  Export To CSV
                </CSVLink>
            }
            {addBroadCastMenuStatus && (
              <AddManageBroadcast
                closeBroadCastMenu={ this.closeBroadCastMenu }
              />
            )}
            { Permission && Permission[ ModuleActions.create ] && (
              <button className='btn btn_primary' onClick={ this.hanldeAddAdmin }>
              <Add /> New Broadcast
            </button>
            )  }
            </div>
          </div>
          <div className='responsive-table ctTableBox'>
            <DataTable
              className='data-table'
              headers={ this.state.headers }
              data={ responseArray }
              noData='No records!'
              sortTable = { this.sortTable }
              activeSort={ this.state.activeSort }
            />
            <Pagination
              handleClick={ this.formUrlParams }
              totalRecords={ totalRecords }
              initialPage={ currentPage }
              setPageLimit={ this.setPageLimit }
              pageLimit={ this.state.pageLimit }
            />
          </div>
        </div>
      </>
    );
  }
}
export default ManageBroadcast;
